export function CloseIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function TrashIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.75 4H11.25M5.25 1.75H8.75M5 6.25V9.5M7 6.25V9.5M9 6.25V9.5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M4 4L4.43718 10.1212C4.50685 11.0967 5.31843 11.85 6.29637 11.85H7.70363C8.68157 11.85 9.49315 11.0967 9.56282 10.1212L10 4"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function EditIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.75 9.95L2.5 11.5L4.05 11.25L10.55 4.75L9.25 3.45L2.75 9.95Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M8.85 3.85L10.15 2.55C10.51 2.19 11.09 2.19 11.45 2.55L11.45 2.55C11.81 2.91 11.81 3.49 11.45 3.85L10.15 5.15"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.75 7.25L5.75 10.25L11.25 3.75"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EyeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M1.25 7C2.4 4.7 4.48 3.5 7 3.5C9.52 3.5 11.6 4.7 12.75 7C11.6 9.3 9.52 10.5 7 10.5C4.48 10.5 2.4 9.3 1.25 7Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="7" r="1.75" stroke="currentColor" strokeWidth="1.25" />
    </svg>
  )
}

export function EyeOffIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M1.25 7C2.4 4.7 4.48 3.5 7 3.5C8.32 3.5 9.53 3.83 10.58 4.47M12.75 7C12.35 7.8 11.84 8.48 11.21 9.03C10.11 9.99 8.68 10.5 7 10.5C4.48 10.5 2.4 9.3 1.25 7Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.55 5.55C5.18 5.92 4.95 6.43 4.95 7C4.95 8.13 5.87 9.05 7 9.05C7.57 9.05 8.08 8.82 8.45 8.45"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M2 2L12 12"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function DragHandleIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <circle cx="3" cy="3" r="1" fill="currentColor" />
      <circle cx="3" cy="6" r="1" fill="currentColor" />
      <circle cx="3" cy="9" r="1" fill="currentColor" />
      <circle cx="9" cy="3" r="1" fill="currentColor" />
      <circle cx="9" cy="6" r="1" fill="currentColor" />
      <circle cx="9" cy="9" r="1" fill="currentColor" />
    </svg>
  )
}

export function DetailsIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M4.25 3H9.75C10.4404 3 11 3.55964 11 4.25V10C11 10.6904 10.4404 11.25 9.75 11.25H4.25C3.55964 11.25 3 10.6904 3 10V4.25C3 3.55964 3.55964 3 4.25 3Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M5 1.75H9"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M5.25 5.5H8.75M5.25 7.5H8.75M5.25 9.5H7.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function TableIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="1.75" y="2" width="10.5" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.25" />
      <path d="M1.75 5.25H12.25M5.25 5.25V12M8.75 5.25V12" stroke="currentColor" strokeWidth="1.25" />
    </svg>
  )
}

export function ProjectIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.25 4.25C2.25 3.55964 2.80964 3 3.5 3H5.4C5.73137 3 6.04946 3.1317 6.28388 3.36612L6.63388 3.71612C6.8683 3.95054 7.18639 4.08224 7.51777 4.08224H10.5C11.1904 4.08224 11.75 4.64188 11.75 5.33224V9.75C11.75 10.4404 11.1904 11 10.5 11H3.5C2.80964 11 2.25 10.4404 2.25 9.75V4.25Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MoveIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M5.25 2.5H2.5V5.25M8.75 2.5H11.5V5.25M5.25 11.5H2.5V8.75M8.75 11.5H11.5V8.75"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 5L2.5 2.5M9 5L11.5 2.5M5 9L2.5 11.5M9 9L11.5 11.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <rect x="5.1" y="5.1" width="3.8" height="3.8" rx="0.8" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  )
}

export function SelectIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.5 4V2.5H4M10 2.5H11.5V4M11.5 10V11.5H10M4 11.5H2.5V10"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 4.75L8.85 6.2L7.4 7.1L8.5 9.5L7.55 9.95L6.45 7.55L5.25 8.85V4.75Z"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RelationshipIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M1.5 10H10.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M7.2 6.7L10.6 10L7.2 13.3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="10.5" y="6" width="8" height="8" rx="1.25" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10.8 9H18.2" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  )
}

export function SettingsIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="2.15" stroke="currentColor" strokeWidth="1.2" />
      <path d="M7 1.9V3.05M7 10.95V12.1M1.9 7H3.05M10.95 7H12.1M3.7 3.7L4.5 4.5M9.5 9.5L10.3 10.3M10.3 3.7L9.5 4.5M4.5 9.5L3.7 10.3" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" />
      <circle cx="7" cy="7" r="4.15" stroke="currentColor" strokeWidth="1.05" />
    </svg>
  )
}

export function ResetZoomIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="6" cy="6" r="2.6" stroke="currentColor" strokeWidth="1.25" />
      <path d="M8.15 8.15L11.25 11.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M6 4.6V7.4M4.6 6H7.4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M2.6 3.4C3.35 2.4 4.58 1.75 6 1.75" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  )
}

export function NewProjectIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2.25 4.25C2.25 3.56 2.81 3 3.5 3H5.4C5.73 3 6.05 3.13 6.28 3.37L6.63 3.72C6.87 3.95 7.19 4.08 7.52 4.08H10.5C11.19 4.08 11.75 4.64 11.75 5.33V9.75C11.75 10.44 11.19 11 10.5 11H3.5C2.81 11 2.25 10.44 2.25 9.75V4.25Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />
      <path d="M7 5.6V8.4M5.6 7H8.4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  )
}

export function SaveIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M3.5 2.25H9.95L11.25 3.55V10.5C11.25 11.05 10.8 11.5 10.25 11.5H3.75C3.2 11.5 2.75 11.05 2.75 10.5V3C2.75 2.59 3.09 2.25 3.5 2.25Z" stroke="currentColor" strokeWidth="1.25" strokeLinejoin="round" />
      <path d="M4.5 2.75V5.2H8.9V2.75M4.8 11.5V8.4H9.2V11.5" stroke="currentColor" strokeWidth="1.15" strokeLinejoin="round" />
    </svg>
  )
}

export function HistoryIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2.5 7A4.5 4.5 0 1 0 4 3.66" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 1.9V4.4H5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 4.6V7L8.85 8.2" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function CalendarIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="2.25" y="3" width="9.5" height="8.5" rx="1.25" stroke="currentColor" strokeWidth="1.25" />
      <path d="M4.5 2V4M9.5 2V4M2.25 5.25H11.75" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  )
}

export function CalendarEditIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="2.25" y="2.5" width="9.5" height="9" rx="1.25" stroke="currentColor" strokeWidth="1.25" />
      <path d="M4.5 2V4M9.5 2V4M2.25 5.25H11.75" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5.3 8.95L5.1 10.2L6.35 10L8.95 7.4L7.9 6.35L5.3 8.95Z" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
      <path d="M7.55 6.7L8.35 5.9C8.58 5.67 8.95 5.67 9.18 5.9C9.41 6.13 9.41 6.5 9.18 6.73L8.38 7.53" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ExportIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M7 2.25V8.1M4.8 5.9L7 8.1L9.2 5.9" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 9.25V10.25C3 10.8 3.45 11.25 4 11.25H10C10.55 11.25 11 10.8 11 10.25V9.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ImportIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M7 8.75V2.9M4.8 5.1L7 2.9L9.2 5.1" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 9.25V10.25C3 10.8 3.45 11.25 4 11.25H10C10.55 11.25 11 10.8 11 10.25V9.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ThemeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M7 2.1V3.15M7 10.85V11.9M2.1 7H3.15M10.85 7H11.9M3.54 3.54L4.28 4.28M9.72 9.72L10.46 10.46M10.46 3.54L9.72 4.28M4.28 9.72L3.54 10.46" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <circle cx="7" cy="7" r="2.2" stroke="currentColor" strokeWidth="1.25" />
    </svg>
  )
}

export function LanguageIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="4.75" stroke="currentColor" strokeWidth="1.25" />
      <path d="M2.7 5.25H11.3M2.7 8.75H11.3M7 2.25C8.18 3.45 8.85 5.15 8.85 7C8.85 8.85 8.18 10.55 7 11.75C5.82 10.55 5.15 8.85 5.15 7C5.15 5.15 5.82 3.45 7 2.25Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    </svg>
  )
}

export function DefaultsIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="2.25" y="2.5" width="9.5" height="9" rx="1.25" stroke="currentColor" strokeWidth="1.25" />
      <path d="M4.25 5H9.75M4.25 7H9.75M4.25 9H7.75" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  )
}

export function GroupsIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="2" y="2.5" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.2" />
      <rect x="8" y="2.5" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.2" />
      <rect x="5" y="7.5" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  )
}

export function ShortcutsIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="1.75" y="3" width="10.5" height="8" rx="1.4" stroke="currentColor" strokeWidth="1.25" />
      <path d="M3.5 5.25H4.5M5.75 5.25H6.75M8 5.25H9M3.5 7.25H5.2M6 7.25H8M8.8 7.25H10.5M3.5 9.25H6.75M7.5 9.25H10.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  )
}

export function HelpIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.25" />
      <path d="M5.65 5.25C5.78 4.25 6.38 3.75 7.35 3.75C8.35 3.75 9 4.31 9 5.15C9 6.02 8.45 6.38 7.85 6.78C7.3 7.15 6.9 7.55 6.9 8.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <circle cx="6.9" cy="10.15" r=".7" fill="currentColor" />
    </svg>
  )
}

export function GridIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="2.25" y="2.25" width="9.5" height="9.5" rx="1.1" stroke="currentColor" strokeWidth="1.25" />
      <path d="M5.42 2.25V11.75M8.58 2.25V11.75M2.25 5.42H11.75M2.25 8.58H11.75" stroke="currentColor" strokeWidth="1.05" />
    </svg>
  )
}

export function AutosaveIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M11.5 4.5A4.75 4.75 0 1 0 12 8.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M11.5 1.8V4.6H8.7" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.8 7L6.4 8.6L9.1 5.9" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function AnimationIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2 9.5C3.2 5.5 5 4.5 6.7 4.5C8.2 4.5 9.55 5.3 12 5.3" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeDasharray="1.8 1.6" />
      <path d="M10.15 3.9L12 5.3L10.15 6.7" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function UserIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="4.4" r="2.15" stroke="currentColor" strokeWidth="1.2" />
      <path d="M2.75 11.1C3.4 9.2 5 8.25 7 8.25C9 8.25 10.6 9.2 11.25 11.1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  )
}

export function LogoutIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M6 2.5H4.25C3.56 2.5 3 3.06 3 3.75V10.25C3 10.94 3.56 11.5 4.25 11.5H6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M7.1 7H11.25M9.45 5.1L11.35 7L9.45 8.9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ChevronDownIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ChevronUpIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M2.5 7.5L6 4L9.5 7.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function WorkspacesIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <rect x="2" y="2.25" width="4.25" height="4.25" rx="0.9" stroke="currentColor" strokeWidth="1.2" />
      <rect x="7.75" y="2.25" width="4.25" height="4.25" rx="0.9" stroke="currentColor" strokeWidth="1.2" />
      <rect x="4.9" y="7.5" width="4.25" height="4.25" rx="0.9" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  )
}

export function FolderOpenIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M2.25 5.25C2.25 4.55964 2.80964 4 3.5 4H5.4C5.73137 4 6.04946 4.1317 6.28388 4.36612L6.63388 4.71612C6.8683 4.95054 7.18639 5.08224 7.51777 5.08224H10.5C11.1904 5.08224 11.75 5.64188 11.75 6.33224V6.75H2.25V5.25Z"
        fill="currentColor"
        fillOpacity="0.25"
      />
      <path
        d="M2.25 6.75H11.75L10.75 10.5C10.6022 11.0 10.15 11.25 9.75 11.25H4.25C3.85 11.25 3.3978 11.0 3.25 10.5L2.25 6.75Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 5.25C2.25 4.55964 2.80964 4 3.5 4H5.4C5.73137 4 6.04946 4.1317 6.28388 4.36612L6.63388 4.71612C6.8683 4.95054 7.18639 5.08224 7.51777 5.08224H10.5C11.1904 5.08224 11.75 5.64188 11.75 6.33224V6.75"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ChevronRightIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path
        d="M4.5 2.5L8 6L4.5 9.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UsersIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="5.5" cy="4.5" r="2" stroke="currentColor" strokeWidth="1.25" />
      <path d="M2 11C2.6 9.2 3.9 8.3 5.5 8.3C7.1 8.3 8.4 9.2 9 11" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M9.5 4.75C10.4 4.75 11 5.38 11 6.25C11 7.12 10.4 7.75 9.5 7.75" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
      <path d="M11.5 11C11.1 9.8 10.4 9.1 9.5 8.85" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  )
}

export function BackIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path
        d="M5.6 3.2L1.9 7L5.6 10.8"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.2 7H12.1"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  )
}
